import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import CategoryValue from './category-value-model'
import {
  CreateCategoryValueAsync,
  DeleteCategoryValueAsync,
  LoadCategoryValuesAsync,
} from './categoryValue-thunk'
const initialState: categoryValueSliceState = {
  categoryValue: [],
  selected_categoryValue: '',
  is_loading_categoryValue: false,
  is_creating_categoryValue: false,
  is_deleting_categoryValue: false,
}
export interface categoryValueSliceState {
  categoryValue: CategoryValue[]
  selected_categoryValue?: string
  is_loading_categoryValue: boolean
  is_creating_categoryValue: boolean
  is_deleting_categoryValue: boolean
}
export const categoryValueSlice = createSlice({
  name: 'categoryValue',
  initialState,
  reducers: {
    setSelectedcategoryValue: (state, action) => {
      state.selected_categoryValue = action.payload
    },
    clearStatecategoryValue: (state) => {
      state.categoryValue = []
      state.is_loading_categoryValue = false
      state.is_creating_categoryValue = false
      state.is_deleting_categoryValue = false
    },
    mergecategoryValue: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_categoryValue = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.categoryValue = merge(state.categoryValue, payload) as any
        }
      }
    },

    add_categoryValue: (state, action) => {
      if (action.payload) {
        state.categoryValue = [...state.categoryValue, action.payload]
      }
    },
    set_categoryValue: (state, action) => {
      let { key, value, id } = action.payload
      state.categoryValue = state.categoryValue.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCategoryValuesAsync.pending, (state) => {
      state.is_loading_categoryValue = true
    })
    builder.addCase(LoadCategoryValuesAsync.fulfilled, (state, action) => {
      state.is_loading_categoryValue = false
      if (action.payload) {
        state.categoryValue = action.payload
      }
    })
    builder.addCase(LoadCategoryValuesAsync.rejected, (state) => {
      state.is_loading_categoryValue = false
    })
    builder.addCase(CreateCategoryValueAsync.pending, (state) => {
      state.is_creating_categoryValue = true
    })
    builder.addCase(CreateCategoryValueAsync.fulfilled, (state) => {
      state.is_creating_categoryValue = false
    })
    builder.addCase(CreateCategoryValueAsync.rejected, (state) => {
      state.is_creating_categoryValue = false
    })
    builder.addCase(DeleteCategoryValueAsync.pending, (state) => {
      state.is_deleting_categoryValue = true
    })
    builder.addCase(DeleteCategoryValueAsync.fulfilled, (state, action) => {
      state.is_deleting_categoryValue = false
      if (state.categoryValue) {
        state.categoryValue = state.categoryValue.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteCategoryValueAsync.rejected, (state) => {
      state.is_deleting_categoryValue = false
    })
  },
})

export const {
  clearStatecategoryValue,
  setSelectedcategoryValue,
  set_categoryValue,
  mergecategoryValue,
  add_categoryValue,
} = categoryValueSlice.actions

export const get_categoryValue =
  (id?: string) =>
  (state: {
    categoryValue: {
      categoryValue: CategoryValue[]
    }
  }): CategoryValue | null => {
    let temp = state?.categoryValue?.categoryValue?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.categoryValue?.categoryValue[0] || null
  }
export const get_selected_categoryValue = (state: {
  categoryValue: categoryValueSliceState
}): CategoryValue | null => {
  let id = state?.categoryValue?.selected_categoryValue
  let temp = state?.categoryValue?.categoryValue?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_categoryValue = (state: {
  categoryValue: {
    categoryValue: CategoryValue[]
  }
}): CategoryValue[] => {
  let temp = state?.categoryValue?.categoryValue
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_categoryValue_busy = (state: {
  categoryValue: categoryValueSliceState
}) => {
  return (
    state?.categoryValue.is_deleting_categoryValue ||
    state?.categoryValue.is_loading_categoryValue ||
    state?.categoryValue.is_creating_categoryValue
  )
}
export const is_deleting_categoryValue_busy = (state: {
  categoryValue: categoryValueSliceState
}) => {
  return state?.categoryValue.is_deleting_categoryValue
}
export const is_loading_categoryValue_busy = (state: {
  categoryValue: categoryValueSliceState
}) => {
  return state?.categoryValue.is_loading_categoryValue
}
export const is_creating_categoryValue_busy = (state: {
  categoryValue: categoryValueSliceState
}) => {
  return state?.categoryValue.is_creating_categoryValue
}

export default categoryValueSlice.reducer
